
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { doFetch } from '../redux/api/actions';
import { useParams } from "react-router-dom";
import { Link } from 'react-router-dom';
import { CURRENT_RECIPE } from '../redux/api/constants';
import withLayout from './withLayout';

function Recipe() {
    const { category_id, recipe_id } = useParams();
    const dispatch = useDispatch()
    const currentRecipe = useSelector(state => state.API.currentRecipe);
    const me = useSelector(state => state.API.me);

    useEffect(() => {
        dispatch(doFetch(
            CURRENT_RECIPE,
            `recipes/${recipe_id}`
        ))
    }, [dispatch, recipe_id]);

    return (
        <>
            {currentRecipe && (
                <>
                    {/* Breadcrumb */}
                    <nav aria-label="breadcrumb" className="mb-3">
                        <ol className="breadcrumb custom-breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to={`/categories/${category_id}`}>{currentRecipe.category}</Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                {currentRecipe.name}
                            </li>
                        </ol>
                    </nav>

                    {currentRecipe.food_image && (
                        <div className="recipe-image mb-4">
                            <img src={currentRecipe.food_image} alt={currentRecipe.name} className="img-fluid" />
                        </div>
                    )}

                    {/* Recipe Card */}
                    <div className="recipe-detail-card card mb-4">
                        <div className="card-body">
                            <h1 className="card-title recipe-title mb-2">{currentRecipe.name}</h1>
                            <div className="recipe-meta mb-3">
                                <span className="me-3">
                                    <strong>Source:</strong> {currentRecipe.source ? currentRecipe.source : "Unknown"}
                                </span>
                                <span>
                                    <strong>Last updated by</strong> <Link to={`/users/${currentRecipe.username}`}>{currentRecipe.username}</Link>&nbsp;
                                    on {currentRecipe.updated_at && new Date(currentRecipe.updated_at).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Ingredients Card */}
                    <div className="recipe-section-card card mb-4">
                        <div className="card-header recipe-section-header">
                            <h2 className="mb-0">Ingredients</h2>
                        </div>
                        <div className="card-body">
                            <ul className="recipe-ingredients-list">
                                {currentRecipe.ingredients && currentRecipe.ingredients.split("\n").filter(ingredient => ingredient.trim() !== "").map((ingredient, index) => (
                                    <li key={index}>{ingredient}</li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    {/* Directions Card */}
                    <div className="recipe-section-card card mb-4">
                        <div className="card-header recipe-section-header">
                            <h2 className="mb-0">Directions</h2>
                        </div>
                        <div className="card-body">
                            <ol className="recipe-directions-list">
                                {currentRecipe.directions && currentRecipe.directions.split("\n").filter(direction => direction.trim() !== "").map((direction, index) => (
                                    <li key={index}>{direction}</li>
                                ))}
                            </ol>
                        </div>
                    </div>

                    {/* Edit Button */}
                    {me && (me.username === currentRecipe.username || me.is_superuser) && (
                        <div className="mb-4">
                            <Link to={`/categories/${category_id}/recipes/${recipe_id}/edit`} className="btn btn-primary">Edit</Link>
                        </div>
                    )}
                </>

            )}
        </>
    );
}
export default withLayout(Recipe);